export default __webpack_public_path__ + "static/media/8-Participating-in-BAPA-Food-Pro-Expo-2018.cf972790.JPG";